module.exports = __webpack_public_path__ + "c09b7ffb5be7c9078035e8b0337cdfb8.jpg";